// @ts-check
import { reduce, isEmpty, isFinite, filter, values } from "lodash";
import { flatBudgetsAsMap } from "./flatBudgetsAsMap";

const createBudgetId = (grouping, parentGrouping) => {
  if (parentGrouping.isSupply) {
    return `${parentGrouping.groupId}-${grouping.groupId}`;
  }

  return `${grouping.groupId}-${parentGrouping.groupId}`;
};

const buildBudgetLookup = ({
  groupLookup,
  rootGroup,
  allocationProjectLookup = {},
}) => {
  const initialMap = {};

  if (
    rootGroup.isSource &&
    !isEmpty(rootGroup.budgets) &&
    // don't run flatBudgetsAsMap twice for the same group if root group is already in groupLookup
    !groupLookup[rootGroup.id]
  ) {
    flatBudgetsAsMap({
      budgetsMap: initialMap,
      group: rootGroup,
      allocationProjectLookup,
    });
  }

  const lookupMap = reduce(
    filter(values(groupLookup), (g) => g.isSource),
    (prev, group) => {
      flatBudgetsAsMap({ budgetsMap: prev, group, allocationProjectLookup });
      return prev;
    },
    initialMap
  );

  return (grouping, targetField) => {
    let { parent: parentGrouping } = grouping;

    while (parentGrouping) {
      if (parentGrouping[targetField]) {
        const budgetId = createBudgetId(grouping, parentGrouping);
        const budget = lookupMap[budgetId];

        if (budget && (isFinite(budget.value) || isFinite(budget.itemsTotal))) {
          grouping.budget = budget;
          return;
        }
      }

      parentGrouping = parentGrouping.parent;
    }
  };
};

export default buildBudgetLookup;
